<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card">
        <md-card-content class="mobile-content">
          <md-list class="md-dense">
            <md-subheader>МОИ ДОМА</md-subheader>
            <md-list-item>
              Успенский, 25
              <a href="#"><md-icon>close</md-icon></a>
            </md-list-item>
            <md-list-item>
              Успенский, 25
              <a href="#"><md-icon>close</md-icon></a>
            </md-list-item>
            <md-list-item :to="{ path: '/settings/set' }"
              >Выбрать другой дом
              <router-link :to="{ path: '/settings/set' }"
                ><md-icon class="md-primary">chevron_right</md-icon></router-link
              ></md-list-item
            >
            <md-divider></md-divider>
          </md-list>
          <md-list class="md-dense">
            <md-subheader>УВЕДОМЛЕНИЯ</md-subheader>
            <md-list-item>
              По выбранным домам <a href="#">включены</a>
            </md-list-item>
          </md-list>
          <md-list class="md-dense">
            <md-subheader>О ПРИЛОЖЕНИИ</md-subheader>
            <md-divider></md-divider>
            <md-list-item to="/components/list/router/1"
              >Сайт приложения
              <a href="#"
                ><md-icon class="md-primary">chevron_right</md-icon></a
              ></md-list-item
            >
            <md-divider></md-divider>
            <md-list-item to="/components/list/router/1"
              >Написать разработчикам
              <a href="#"
                ><md-icon class="md-primary">chevron_right</md-icon></a
              ></md-list-item
            >
            <md-divider></md-divider>
            <md-list-item to="/components/list/router/1"
              >Поделится с друзьями
              <a href="#"
                ><md-icon class="md-primary">chevron_right</md-icon></a
              ></md-list-item
            >
            <md-divider></md-divider>
            <md-list-item to="/components/list/router/1"
              >Оценить приложение
              <a href="#"
                ><md-icon class="md-primary">chevron_right</md-icon></a
              ></md-list-item
            >
          </md-list>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserSettingsPage"
};
</script>
<style scoped lang="scss">
.md-list-item-container,
.md-list-item-content {
  font-size: 14px !important;
  text-transform: initial;
}
</style>
